import isNull from "lodash-es/isNull"

const domParser: DOMParser = new DOMParser()

function isStringHTML(content: string): boolean {
    try {
        const parsedDocument: Document = domParser.parseFromString(content, "text/html")

        return parsedDocument.body.childElementCount > 0 && isNull(parsedDocument.querySelector("parsererror"))
    } catch (_error) {
        return false
    }
}

function isStringMarkdown(content: string): boolean {
    const htmlTagPattern: RegExp = /<\/?[a-z][\s\S]*>/i

    if (htmlTagPattern.test(content)) {
        return false
    }

    const markdownPattern: RegExp = /(\*\*|__|\*|_|~~|#|-|\+|\d+\.)/

    return markdownPattern.test(content)
}

function isStringPlainText(content: string): boolean {
    const htmlPattern: RegExp = /<\/?[a-z][^>]*>/i
    const markdownPattern: RegExp = /(^\s{0,3}#{1,6}\s|[*_`~]|!\[.*]\(.*\)|\[(.*?)]\((.*?)\))/m

    return !htmlPattern.test(content) && !markdownPattern.test(content)
}

type TUtils = {
    isStringHTML(content: string): boolean
    isStringMarkdown(content: string): boolean
    isStringPlainText(content: string): boolean
}

const richTextRendererUtils: TUtils = { isStringHTML, isStringMarkdown, isStringPlainText }

export { richTextRendererUtils, type TUtils as TRichRendererUtils }
